import moment from 'moment'
import axiosInstance from './axiosConfig'
import { download, getExcelFileName } from '@app/utils/helpers'
import { createCancelToken } from './axiosUtils'

const FileAPI = {
  export: function ({ org_id, folder_id, folder_name, export_type, label_ids, submission_ids, ...params }) {
    let url = `/folders/${org_id}/${folder_id}/submissions/export-${export_type}`
    let data = { label_ids, submission_ids }

    if (export_type === 'table') {
      url = `/submissions/${org_id}/${folder_id}/${submission_ids[0]}/export-${export_type}`
      data = { label_ids }
    }

    if (export_type === 'finance-report') {
      url = `/submissions/${org_id}/${folder_id}/${submission_ids[0]}/export-${export_type}`
      data = {}
    }

    return axiosInstance
      .request({
        method: 'POST',
        url,
        data,
        params,
        responseType: 'blob',
      })
      .then(res => {
        const filename = getExcelFileName(folder_name)
        download(res.data, filename)
      })
  },
  downloadFile: function ({ org_id, folder_id, submission_id, file }) {
    const { id, name } = file
    return axiosInstance
      .request({
        method: 'GET',
        url: `/files/${org_id}/${folder_id}/${submission_id}/${id}/document`,
        responseType: 'blob',
      })
      .then(res => {
        download(res.data, name)
      })
  },
}

const cancelTokenObject = createCancelToken(FileAPI)
export default FileAPI
